import { useEffect, useState } from "react";
import useAPI from "../../../services/hooks/useAPI";
import searchAPI from "../../API/searchAPI";
import { useLocation, useNavigate } from "react-router-dom";
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import SearchBar from "../../app/SearchBar/SearchBar";
import { Button, Skeleton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ViewDownloadsDialog } from "../../dialogs/View-Downloads-Dialog";
import { useAuth } from "../../../hooks/useAuth";
import './style.scss';
import axios from "axios";
import { CacheService } from "../../../common/services/cache.service";
import environment from "../../../environment/environment";
import APIService from "../../../services/api.service";
import { OrderDownloadDialog } from "../../dialogs/Order-Download-Dialog";
import { tokenState } from "../../../atoms/token";
import { useRecoilState } from "recoil";

const OrderHistory = () => {
  const { user } = useAuth();

  const [showDialog, setShowDialog] = useState(false);
  const [showDownloadDialog, setShowDownloadDialog] = useState(false);
  const [row, setRow] = useState(null);
  const [orders, setOrders] = useState([]);
  const [reload, setReload] = useState(false);
  const [token] = useRecoilState(tokenState);
  
  useEffect(() => {
    getOrders();

    setReload(false);
  }, [reload]);

  const getOrders = () => { 
    console.log('get orders');

    const url = `${environment.eticApiUrl}getorders?userid=current&pageSize=20000`;
    const apiService = new APIService<any>(axios, new CacheService, url, token);

    apiService.getAnyAsync().then((res:any) => {
      console.log('orders', res);
      setOrders(res.data.sort((a, b) => (a.date > b.date) ? -1 : 1));
    });
  }

  const handleRowClick = (rowArgs, event) => {
    setShowDownloadDialog(true);
    setRow(rowArgs.row);
  }

  const handleRowBtnClick = (event, rowParams) => { 
    setShowDownloadDialog(true);
    setRow(rowParams.row);
  }

  const handleCloseClick = () => {
    setShowDialog(false);
    setShowDownloadDialog(false);
    setRow(null);
  }

  const formatDate = (date) => { 
    let d = new Date(date);
    return d.toLocaleDateString();
  }
 
  const columns: GridColDef[] = [
    { field: 'custName', headerName: 'Cust. Name', width: 250 },
    { field: 'email', headerName: 'Cust. Email', width: 250 },
    { field: 'staffName', headerName: 'Tic Staff Asgmt', width: 250 },
    { field: 'staffEmail', headerName: 'Staff Email', width: 250 },
    { field: 'status', headerName: 'Status', width: 150 },
    { field: 'date', headerName: 'Date Added', width: 150 },
    { field: 'view', headerName: 'Order Details',
      hideSortIcons: true,
      width: 150,
      renderCell: (cellValues) => {
        return (
          <Button
            variant={"contained"} 
            color={"primary"}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              handleRowBtnClick(event, cellValues);
            }}           
            startIcon={<FontAwesomeIcon icon={["fas", "eye"]}/>}
          >
            View Order
          </Button>
        );
      }
    },
   
  ];
  
  return (
    <>
    {showDownloadDialog &&
      <OrderDownloadDialog
        row={row}
        handleCloseClick={handleCloseClick}
      />
    }

    <h1 className="center">Order History</h1>
    <h2 className="center">{user?.profile?.name}</h2>
      <div className="search-results">
      <div className="center" style={{ height: 400, width: '100%' }}>
          <DataGrid
             sx={{ '.MuiDataGrid-columnHeaderTitle': {fontWeight: 'bolder'},
             '.MuiDataGrid-row': {cursor: 'pointer', borderBottom: 1},
             '.MuiDataGrid-columnHeaderTitleContainer': {borderBottom: 1 },
             '.MuiDataGrid-iconButtonContainer': {visibility: 'visible' },
             '.MuiDataGrid-sortIcon': {opacity: 'inherit !important' }
            }}
            rows={orders.map((result, index) => (
              {
                id: result?.id,
                date: formatDate(result?.date),
                staffName: result?.staffName,
                staffEmail: result?.staffEmail,
                email: result?.email,
                custName: result?.firstName + ' ' + result?.lastName,
                status: result?.status,
                userId: result?.userId,
              }
            )) || []}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 5 },
              },
            }}
            pageSizeOptions={[5, 10, 25, 50]}
            onRowClick={handleRowClick}
            disableRowSelectionOnClick
            loading={orders.length === 0}
          />
        </div>
      </div>
    </>
  );
}

export default OrderHistory;